import {
    Flex,
    Box,
    FormControl,
    Input,
    Checkbox,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
    chakra,
    InputGroup,
    InputLeftElement,
    InputRightElement,
    Spinner,
    Center,
    VStack,
    ScaleFade,
} from '@chakra-ui/react';
import React from 'react';
import { FaLock, FaUserAlt } from 'react-icons/fa';
import { useAuthState, useSignInWithEmailAndPassword } from 'react-firebase-hooks/auth';
import { auth } from "../../../utils/firebase";
import { Redirect } from 'react-router-dom';
import { DataContext } from '../../../state/DataContext/DataContext';
import { useForm } from 'react-hook-form';
import {
    Link,
} from "react-router-dom";
import RedirectIfLoggedIn from '../../Shared/RedirectIfLoggedIn/RedirectIfLoggedIn';


export default function SimpleCard() {
    const { data, actions } = React.useContext(DataContext as any);

    React.useEffect(() => {
        actions.Auth.Clear();
    }, [])

    const [showPassword, setShowPassword] = React.useState(false);
    const handleShowClick = () => setShowPassword(!showPassword);
    const CFaUserAlt = chakra(FaUserAlt);
    const CFaLock = chakra(FaLock);
    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    const [
        signInWithEmailAndPassword,
        user,
        loading,
        error,
    ] = useSignInWithEmailAndPassword(auth);

    const onSubmit = data => signInWithEmailAndPassword(data.email, data.password);

    return (
        <ScaleFade initialScale={0.1} in>
            <Flex
                minH={'100vh'}
                align={'center'}
                justify={'center'}
                bg={useColorModeValue('gray.50', 'gray.800')}>
                <RedirectIfLoggedIn />
                <Stack spacing={6} mx={'auto'} maxW={'lg'} py={12} px={6}>
                    <Stack align={'center'}>
                        <Heading fontSize={'4xl'}><Text display="inline" fontWeight="black" color="green.500">Job</Text><Text display="inline" fontWeight="bold">WorkPad</Text></Heading>
                        <Text textAlign={"center"} fontSize={'lg'} color={'gray.600'}>
                            A collaborative <br /> Job Checking Platform <br />
                        </Text>

                        <Text textAlign={"center"} fontSize={'lg'} color={'gray.600'}>
                            <b>Use this credential below to try</b> <br />
                            user: test@gmail.com <br />
                            password: password <br />
                        </Text>

                    </Stack>
                    <Box
                        borderRadius="1.5em"
                        bg={useColorModeValue('white', 'gray.700')}
                        boxShadow={'lg'}
                        p={8}>
                        {loading ? <Center><Spinner /></Center> :
                            <form onSubmit={handleSubmit(onSubmit)}>
                                {error?.message}
                                <Stack spacing={4}>
                                    <FormControl id="email">
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents="none"
                                                children={<CFaUserAlt color="gray.300" />}
                                            />
                                            <Input {...register("email")} type="email" placeholder="Email address" />
                                        </InputGroup>
                                    </FormControl>
                                    <FormControl id="password">
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents="none"
                                                color="gray.300"
                                                children={<CFaLock color="gray.300" />}
                                            />
                                            <Input {...register("password")}
                                                type={showPassword ? "text" : "password"}
                                                placeholder="Password"
                                            />
                                            <InputRightElement width="4.5rem">
                                                <Button h="1.75rem" size="sm" onClick={handleShowClick}>
                                                    {showPassword ? "Hide" : "Show"}
                                                </Button>
                                            </InputRightElement>
                                        </InputGroup>
                                    </FormControl>
                                    <Stack >
                                        <VStack
                                            direction={{ base: 'column', sm: 'row' }}
                                            align={'start'}
                                            justify={'space-between'}>
                                            <Checkbox>Remember me</Checkbox>

                                        </VStack>
                                        <Button
                                            type="submit"
                                            bg={'green.500'}
                                            color={'white'}
                                            _hover={{
                                                bg: 'green.400',
                                            }}
                                            borderRadius="1.5em"
                                        >
                                            Sign in
                                        </Button>
                                        <Box>
                                            {/* <Link to="/"><Text color={'blue.400'}>Forgot password?</Text></Link> */}
                                        </Box>
                                        <Link to="/signup" color={'blue.400'}>
                                            <Text color={'blue.400'}>New User?</Text>
                                        </Link>
                                    </Stack>
                                </Stack>
                            </form>
                        }
                    </Box>
                </Stack>
            </Flex>
        </ScaleFade>
    );
}


// import { useState } from "react";
// import {
//     Flex,
//     Heading,
//     Input,
//     Button,
//     InputGroup,
//     Stack,
//     InputLeftElement,
//     chakra,
//     Box,
//     Avatar,
//     FormControl,
//     FormHelperText,
//     InputRightElement,
//     Text
// } from "@chakra-ui/react";
// import { FaUserAlt, FaLock } from "react-icons/fa";
// import {
//     BrowserRouter as Router,
//     Switch,
//     Route,
//     Link
// } from "react-router-dom";

// const CFaUserAlt = chakra(FaUserAlt);
// const CFaLock = chakra(FaLock);

// const Login = () => {
//     const [showPassword, setShowPassword] = useState(false);

//     const handleShowClick = () => setShowPassword(!showPassword);

//     return (
//         <Flex
//             flexDirection="column"
//             width="100wh"
//             height="100vh"
//             backgroundColor="gray.100"

//             justifyContent="center"
//             alignItems="center"
//         >
//             <Stack
//                 flexDir="column"
//                 mb="2"
//                 justifyContent="center"
//                 alignItems="center"
//             >
//                 <Heading color="teal.400">Welcome</Heading>
//                 <Box minW={{ base: "90%", md: "468px" }}>
//                     <form>
//                         <Stack
//                             spacing={4}
//                             p="1rem"
//                             backgroundColor="whiteAlpha.900"
//                             boxShadow="md"
//                             borderRadius="0.5em"
//                         >
//                             <FormControl>
//                                 <InputGroup>
//                                     <InputLeftElement
//                                         pointerEvents="none"
//                                         children={<CFaUserAlt color="gray.300" />}
//                                     />
//                                     <Input type="email" placeholder="Email address" />
//                                 </InputGroup>
//                             </FormControl>
//                             <FormControl>
//                                 <InputGroup>
//                                     <InputLeftElement
//                                         pointerEvents="none"
//                                         color="gray.300"
//                                         children={<CFaLock color="gray.300" />}
//                                     />
//                                     <Input
//                                         type={showPassword ? "text" : "password"}
//                                         placeholder="Password"
//                                     />
//                                     <InputRightElement width="4.5rem">
//                                         <Button h="1.75rem" size="sm" onClick={handleShowClick}>
//                                             {showPassword ? "Hide" : "Show"}
//                                         </Button>
//                                     </InputRightElement>
//                                 </InputGroup>
//                                 <FormHelperText textAlign="right">
//                                     {/* <Link>forgot password?</Link> */}
//                                 </FormHelperText>
//                             </FormControl>
//                             <Button
//                                 borderRadius={0}
//                                 type="submit"
//                                 variant="solid"
//                                 colorScheme="teal"
//                                 width="full"
//                             >
//                                 Login
//                             </Button>
//                         </Stack>
//                     </form>
//                 </Box>
//             </Stack>
//             <Box>
//                 <Flex>
//                     <Text marginRight="5px">
//                         New to us?{" "}
//                     </Text>
//                     <Link to="/signup">
//                         <Text color="teal.500" >Sign Up </Text>
//                     </Link>
//                 </Flex>
//             </Box>
//         </Flex>
//     );
// };

// export default Login;
